import React from 'react';

import { useActiveUser } from '@api/users/api.users.queries';

import { AuthProviderContext } from './AuthProvider.context';

import type {
  AuthContextProperties,
  AuthProviderProperties,
} from './AuthProvider.types';

export const AuthProvider: React.FC<AuthProviderProperties> = ({
  children,
}) => {
  const { data: user } = useActiveUser();

  const value = React.useMemo<AuthContextProperties>(() => {
    return user;
  }, [user]);

  return (
    <AuthProviderContext.Provider value={value}>
      {children}
    </AuthProviderContext.Provider>
  );
};
